var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ui-view",
    {
      directives: [
        {
          name: "spinner",
          rawName: "v-spinner",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "view-ship-form",
      attrs: { hide: _vm.loading },
    },
    [
      _c(
        "ui-heading",
        { attrs: { title: _vm.pageTitle, icon: "fa-ship" } },
        [
          _c(
            "ui-button",
            {
              attrs: { color: "positive", loading: _vm.submitting },
              on: {
                click: function ($event) {
                  return _vm.$refs.form.submit()
                },
              },
            },
            [_vm._v("Opslaan")]
          ),
          _vm.shipId
            ? _c(
                "ui-button",
                {
                  attrs: { color: "negative", icon: "magicon-trash" },
                  on: { click: _vm.deleteShip },
                },
                [_vm._v("Verwijderen")]
              )
            : _vm._e(),
          _c(
            "ui-button",
            {
              attrs: { slot: "left", color: "medium", type: "bordered" },
              on: {
                click: function ($event) {
                  return _vm.$router.go(-1)
                },
              },
              slot: "left",
            },
            [_vm._v("Annuleren")]
          ),
        ],
        1
      ),
      _c(
        "ui-form-panel",
        {
          ref: "form",
          attrs: { "auto-validate": "" },
          on: { submit: _vm.submit },
        },
        [
          _c("ui-form-input", {
            attrs: { title: "Naam", name: "name", rules: "required" },
            model: {
              value: _vm.pendingShip.name,
              callback: function ($$v) {
                _vm.$set(_vm.pendingShip, "name", $$v)
              },
              expression: "pendingShip.name",
            },
          }),
          !_vm.shipId && this.$user.role !== "GROWER"
            ? _c("ui-form-dropdown", {
                attrs: {
                  title: "Kweker",
                  name: "growerId",
                  options: _vm.growerOptions,
                  rules: "required",
                },
                model: {
                  value: _vm.pendingShip.growerId,
                  callback: function ($$v) {
                    _vm.$set(_vm.pendingShip, "growerId", $$v)
                  },
                  expression: "pendingShip.growerId",
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }